import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import WidgetShell from '../WidgetShell';
import Spinner from '../../Spinner';
import axios from '../../../utils/axios';

const TrendingWidget = () => {
  const { t } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery(
    ['trending'],
    async () => {
      const response = await axios.get('/api/trending');
      return response.data;
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );

  const items = useMemo(() => data?.trending || [], [data]);

  return (
    <WidgetShell title={t('rightSidebar.widgets.trending.title')}>
      {isLoading && (
        <div className="flex items-center justify-center py-6">
          <Spinner />
        </div>
      )}
      {!isLoading && isError && (
        <div className="px-4 py-4 text-sm text-on-surface/70">
          {t('rightSidebar.widgets.trending.error')}{' '}
          <button
            type="button"
            onClick={() => refetch()}
            className="text-primary hover:underline"
          >
            {t('rightSidebar.widgets.trending.retry')}
          </button>
        </div>
      )}
      {!isLoading && !isError && items.length === 0 && (
        <p className="px-4 py-4 text-sm text-on-surface/70">
          {t('rightSidebar.widgets.trending.empty')}
        </p>
      )}
      {!isLoading && !isError && items.length > 0 && (
        <ul className="flex flex-col">
          {items.map((item, idx) => (
            <li key={`${item.type}:${item.tag}`}>
              <Link
                to={`/search?q=${encodeURIComponent(item.tag)}&tab=posts`}
                className="flex items-start justify-between gap-2 px-4 py-2 hover:bg-on-surface/5 transition-colors"
              >
                <div className="min-w-0">
                  <p className="text-xs text-on-surface/50">
                    {idx + 1} ·{' '}
                    {t(`rightSidebar.widgets.trending.${item.type}`)}
                  </p>
                  <p className="text-sm font-semibold text-on-surface truncate">
                    {item.type === 'hashtag' ? item.tag : item.tag}
                  </p>
                </div>
                <span className="text-xs text-on-surface/50 whitespace-nowrap pt-0.5">
                  {item.count} {t('rightSidebar.widgets.trending.posts')}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </WidgetShell>
  );
};

export default TrendingWidget;
